module.exports = __webpack_public_path__ + "img/closeWhite.fec291fc.svg";